'use client'
import { StorageService } from '@dynamic-labs/utils';
import { isAuthTokenExpired } from '../../../context/DynamicContext/helpers/helpers.js';
import { AUTH_TOKEN } from '../../constants/localStorage.js';
import '../../constants/colors.js';
import '../../constants/values.js';

const getAuthToken = () => {
    if (typeof window === 'undefined') {
        return undefined;
    }
    const token = StorageService.getItem(AUTH_TOKEN, {
        priority: ['secureStorage', 'localStorage'],
    });
    if (!token || isAuthTokenExpired(token)) {
        return undefined;
    }
    return token;
};

export { getAuthToken };
